var render = function render(){var _vm=this,_c=_vm._self._c;return _c('revisi-proposal',{attrs:{"taType":3,"route":"/ta/revisi","page":"TA"}})
}
var staticRenderFns = []

export { render, staticRenderFns }